import React from 'react';
import {useTranslation} from "react-i18next";
import {FormattedPhoneNumber} from "../../../components/Common/FormattedPhoneNumber";

interface Props {
    order: any
}

const SummaryContactComponent = (props: Props) => {
    const {t} = useTranslation();

    const hasContactInformation = () => {
        if(!props.order.contact) return false;

        return Object.entries(props.order.contact).some(([_, value]) => value);
    }

    if (!(hasContactInformation())) return null;

    return (
        <div className={"card-cart"}>
            <div className={"container-fluid"}>
                <h3 className={"card-cart-header"}>{t("common.word.your_data")}</h3>
                <div className={"card-cart-body"}>
                    <div className={"cart-card-info"}>
                        {
                            props.order.contact?.name && (
                                <dl>
                                    <dt>{t("common.word.full_name")}:</dt>
                                    <dd>{props.order.contact.name}</dd>
                                </dl>
                            )
                        }
                        {
                            props.order.contact?.email && (
                                <dl>
                                    <dt>{t("common.word.email")}:</dt>
                                    <dd>{props.order.contact.email}</dd>
                                </dl>
                            )
                        }
                        {
                            props.order.contact?.phone && (
                                <dl>
                                    <dt>{t("common.word.phone_number")}:</dt>
                                    <dd><FormattedPhoneNumber phoneNumber={props.order.contact.phone}/></dd>
                                </dl>
                            )
                        }
                    </div>
                </div>
            </div>
        </div>
    );
}
export default SummaryContactComponent;